import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './actions';
import { isEmpty, filter } from 'lodash';
import * as routes from '../../../routes/const';

import { NitroLoading } from 'nitro-components';
import QuestionCard from './components/QuestionCard';
import QuestionBanner from './components/QuestionBanner';


/**
 * QuoteQuestions
 *
 * quote questions is the container component for the first step of the
 * Corporate Quote creation flow. it requests a set of questions which are
 * specific to the user, and depending on the answers provided will direct
 * them to the vehicle select screen, or bump them to the declined quote view
 */
class QuoteQuestions extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      currentQuestionIndex: 0,
      quoteIsDeclined: false
    };

    this.handleQuestionResponse = this.handleQuestionResponse.bind(this);
    this.showPreviousQuestion = this.showPreviousQuestion.bind(this);
  }

  componentWillMount() {
    const {
      updateStep,
      fetchQuestions,
      clearQuestionAnswers
    } = this.props.actions;

    updateStep(1);
    clearQuestionAnswers();
    fetchQuestions();
  }

  /**
   * componentWillReceiveProps
   * before each new update to the UI, we need to do two things
   * - has the user given an answer which results in a delined quote?
   * - has the user answered all of the questions
   * if either are true, we re-direct to a new route.
   */
  componentWillReceiveProps(nextProps) {
    const { router } = this.context;
    const { questions, answers, fetchingQuestions } = nextProps;
    const { currentQuestionIndex } = this.state;
    const total = questions.length - 1;
    const declined = this.shouldQuoteBeDeclined(questions, answers, currentQuestionIndex);

    if (isEmpty(questions) && !fetchingQuestions) router.push(routes.CQ_CREATE_VEHICLE);
    else if (declined) router.push(routes.CQ_CREATE_DECLINED);
    else if (currentQuestionIndex === total) router.push(routes.CQ_CREATE_VEHICLE);
  }

  /**
   * shouldComponentUpdate
   * dont try and render if the currentQuestionIndex excedes the number of
   * available questions
   */
  shouldComponentUpdate(nextProps, nextState) {
    const { questions } = this.props;
    const { currentQuestionIndex } = nextState;
    const total = questions.length;

    return !currentQuestionIndex || currentQuestionIndex < total;
  }

  /**
   * shouldQuoteBeDeclined
   * called from componentWillReceiveProps. checks if the last answer given
   * by the user matches a predicate which results in a declined quote.
   */
  shouldQuoteBeDeclined(questions, answers, index) {
    // can't be declined if nothing has been answered yet..
    if (isEmpty(answers)) return false;

    const { QuestionOptions, InputFieldName } = questions[index];
    const { declineIf } = JSON.parse(QuestionOptions);

    // can't be declined if there is no predicate
    if (!declineIf) return false;

    // get the user selected answer by InputFieldName for comparison
    const answerArr = filter(answers, a => a.InputFieldName === InputFieldName);
    const answer = !isEmpty(answerArr) ? answerArr[0].Answer : '';

    // normalise and compare the predicate and the answer
    return (declineIf.toLowerCase() === answer.toLowerCase());
  }

  setCurrentQuestionIndex(index) {
    this.setState({ currentQuestionIndex: index });
  }

  showPreviousQuestion() {
    const { currentQuestionIndex } = this.state;

    // only if it's not the first question
    if (currentQuestionIndex > 0 )
      this.setCurrentQuestionIndex(currentQuestionIndex - 1);
  }

  /**
   * handleQuestionResponse
   * this method is passed as a callback to the QuestionCard, and is used
   * to dispatch the action to update the redux store with the new answer
   * and update the current question index
   */
  handleQuestionResponse(name, id, value) {
    const { currentQuestionIndex } = this.state;
    const { setQuestionAnswer } = this.props.actions;

    setQuestionAnswer(name, id, value);
    this.setCurrentQuestionIndex(currentQuestionIndex + 1);
  }

  render() {
    const { currentQuestionIndex } = this.state;
    const { questions, answers } = this.props;

    // you shall not pass (without questions)
    if (isEmpty(questions)) return <NitroLoading screen />;

    // extract the values required for the question card
    const { Label, InputFieldOptions, Id, InputFieldName } = questions[currentQuestionIndex];
    const options = JSON.parse(InputFieldOptions);

    return (
      <section>
        <QuestionBanner />
        <QuestionCard
          total={questions.length}
          index={currentQuestionIndex}
          name={InputFieldName}
          id={Id}
          onBack={this.showPreviousQuestion}
          title={Label}
          options={options}
          answers={answers}
          handleResponse={this.handleQuestionResponse}
        />
      </section>
    );
  }
}

QuoteQuestions.propTypes = {
  questions: PropTypes.array.isRequired,
  answers: PropTypes.array.isRequired,
  fetchingQuestions: PropTypes.bool.isRequired,
  actions: PropTypes.object.isRequired
};

QuoteQuestions.contextTypes = {
  router: PropTypes.object
};

const mapStateToProps = state => {
  const { questions, answers, fetchingQuestions } = state.corporateQuote.create;
  return { questions, answers, fetchingQuestions };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(QuoteQuestions);



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/QuoteQuestions.js